import { render, staticRenderFns } from "./ShowTourButton.vue?vue&type=template&id=680c6f6c&scoped=true"
import script from "./ShowTourButton.vue?vue&type=script&lang=js"
export * from "./ShowTourButton.vue?vue&type=script&lang=js"
import style0 from "./ShowTourButton.vue?vue&type=style&index=0&id=680c6f6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c6f6c",
  null
  
)

export default component.exports